import { render, staticRenderFns } from "./PnlChart.vue?vue&type=template&id=6d13805d&scoped=true&lang=pug"
import script from "./PnlChart.vue?vue&type=script&lang=js"
export * from "./PnlChart.vue?vue&type=script&lang=js"
import style0 from "./PnlChart.vue?vue&type=style&index=0&id=6d13805d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d13805d",
  null
  
)

export default component.exports